import { createFileRoute, redirect, useParams } from "@tanstack/react-router";
import { WorkflowBuilder } from "./-workflow-builder/WorkflowBuilder";
import { queryClient, trpc } from "~/utils/trpc";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { hasPermission, useHasPermission } from "~/store/usePermissionStore";

export const Route = createFileRoute("/_dashboard/$datasetSlug/automations/$automationId/builder")({
  beforeLoad: async ({ params }) => {
    const session = await queryClient.fetchQuery(trpc.auth.getSession.queryOptions()).catch(() => null);

    if (!hasPermission({ role: session?.user?.role, permissions: session?.user?.permissions }, "automations", "view")) {
      throw redirect({ to: "/$datasetSlug/dashboard", params: { datasetSlug: params.datasetSlug } });
    }
  },
  component: RouteComponent,
  loader: async ({ params }) => {
    const automation = await queryClient.fetchQuery(
      trpc.automations.getById.queryOptions({ id: params.automationId }, { refetchOnMount: true }),
    );
    if (!automation) throw new Error("Automation not found");
    return { automation };
  },
});

function RouteComponent() {
  const { automation } = Route.useLoaderData();
  const { datasetSlug } = useParams({ from: "/_dashboard/$datasetSlug" });
  const canUpdateAutomations = useHasPermission("automations", "update");
  useBreadCrumbs([
    { title: "Automations", link: `/${datasetSlug}/automations` },
    { title: "Details", link: `/${datasetSlug}/automations/${automation.id}` },
    { title: "Builder", link: `/${datasetSlug}/automations/${automation.id}/builder` },
  ]);
  return (
    <div className="flex flex-1">
      <WorkflowBuilder
        automationId={automation.id}
        initialName={automation.name}
        automation={automation}
        readOnly={!canUpdateAutomations}
      />
    </div>
  );
}
